/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 8/12/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */

const PERM = {
  Web: 1,
  Flashmail: 2,
  Yixin: 4,
  Pop: 8,
  Imap: 16,
  Smtp: 32,
  AddrRight: 64,
  AddrVisible: 128,
  BigAttachment: 256,
  IsArchive: 512,
  ReceiveLimit: 1024,
  SendLimit: 2048,
  ResetpassGeneral: 4096,
  ResetpassMobile: 8192,
  Dashi: 16384
};

export default PERM;
